export const paths = {
    card : 'c',
    checkout : 'checkout',
    event : '/e'

}